export default "__VITE_ASSET__DBcJi$dC__"